<div class="number text-10 text-medium">
    <div>{{ number }}</div>
</div>